import {WixSdk} from '@wix/js-sdk-wrapper';
import {parseParams} from '@wix/music-shared/dist/src/utils/url';

import {SiteInfo} from '../../typings/sdk';

export {createParam} from '@wix/music-shared/dist/src/utils/url';

export function getHostname(url: string) {
  return url.split(/\/+/)[1];
}

export function getUrlPrefixes() {
  return {
    audio: WixSdk.Utils.Media.getAudioUrl('', WixSdk.Utils.Media.AudioType.PREVIEW)
      .replace(/https?:/, '')
      .replace('static.wixstatic.com', 'music.wixstatic.com'),
    image: `//${getHostname(WixSdk.Media.getResizedImageUrl(''))}/`,
  };
}

export function getSharedTrackId(siteInfo: SiteInfo): number | undefined {
  if (!siteInfo || !siteInfo.url) {
    return;
  }
  const queryString = siteInfo.url.split('?')[1] || '';
  const query = parseParams(queryString);
  const queryCompId = query['wix-music-comp-id'];
  const trackId = parseInt(query['wix-music-track-id'], 10);

  if (queryCompId === WixSdk.Utils.getCompId() && Number.isInteger(trackId)) {
    return trackId;
  }
}
